import { render, staticRenderFns } from "./webpage_edit.vue?vue&type=template&id=456cc345&"
import script from "./webpage_edit.vue?vue&type=script&lang=js&"
export * from "./webpage_edit.vue?vue&type=script&lang=js&"
import style0 from "./webpage_edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports